import React from "react"

const SaBackMainA = ({ fillColor, strokeColor }) => (
  <g id="main_fabric_font_a-back">
    <path d="M228.6 286.4c2.7.1 5 .2 6.5.3 1.1.1 2.2.6 3 1.4.6.5 1.3 1.4 1.7 2.4-2.6-.1-6.4-.2-10.4-.2.3-1.1-.3-2.9-.8-3.9zm-209.9 0c-.5.9-1.1 2.7-.8 3.9-5 0-10.1.1-13.4.2.5-1 1.1-1.8 1.7-2.4.8-.8 1.9-1.3 3-1.4 2.1-.2 5.6-.3 9.5-.3z" fill={fillColor} fillRule="nonzero"/>
    <path d="M228.6 286.4c2.7.1 5 .2 6.5.3 1.1.1 2.2.6 3 1.4.6.5 1.3 1.4 1.7 2.4-2.6-.1-6.4-.2-10.4-.2.3-1.1-.3-2.9-.8-3.9zm-209.9 0c-.5.9-1.1 2.7-.8 3.9-5 0-10.1.1-13.4.2.5-1 1.1-1.8 1.7-2.4.8-.8 1.9-1.3 3-1.4 2.1-.2 5.6-.3 9.5-.3z" fillRule="nonzero" stroke={strokeColor} strokeLinecap="round" strokeLinejoin="round" strokeWidth=".5"/>
  </g>
)

export default SaBackMainA